/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Input, Label } from 'reactstrap';

import { noop } from 'lib/noop';
import { isBlank } from 'lib/string';
import { ClearButton } from 'ui/Components';

import styles from './PlacementOnlyTab.css';
import { AMP_PLACEMENT_SWATCHES, AMP_PLACEMENT_URL } from '../const';

/**
 * controls for placement only tab on amp modal
 */
export default class PlacementOnlyTab extends Component {
  static propTypes = {
    onAsset: propTypes.func
  };

  static defaultProps = {
    onAsset: noop
  };

  state = {
    ampValue: 0,
    height: '',
    width: ''
  };

  /**
   * check whether either height or width value is missing
   * @returns {boolean} true if either value is missing, otherwise false
   */
  get isInProgress() {
    const { height, width } = this.state;
    return [height, width].some(isBlank);
  }

  /**
   * call `onAsset` prop with complete placement url
   */
  handleAssetUpdate = () => {
    const { onAsset } = this.props;
    const { ampValue, height, width } = this.state;

    if (!this.isInProgress) {
      const asset = new URL(`${AMP_PLACEMENT_URL}/${ampValue}`);
      asset.searchParams.set('h', height);
      asset.searchParams.set('w', width);

      onAsset(asset);
    }
  };

  /**
   * a generic handler for onChange events
   * update internal state based on event target name and value
   * @param {object} event - the event to be handled
   */
  handleInputChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value.trim() }, this.handleAssetUpdate);
  };

  /**
   * update `ampValue` internal state based on swatch button value
   * @param {object} event - click event
   */
  handleSwatchClick = event => {
    const { value: ampValue } = event.target;
    this.setState({ ampValue }, this.handleAssetUpdate);
  };

  /**
   * reset input state
   */
  resetInputState = () => {
    this.setState({
      ampValue: 0,
      height: '',
      width: ''
    });
  };

  render() {
    const { height, width } = this.state;
    return (
      <div className="d-flex flex-column mx-4">
        <Label className="font-weight-bold mt-4" for="widthInput">
          Width (px)
        </Label>
        <Input
          id="widthInput"
          name="width"
          onChange={this.handleInputChange}
          type="text"
          value={width}
        />
        <Label className="font-weight-bold mt-4" for="heightInput">
          Height (px)
        </Label>
        <Input
          id="heightInput"
          name="height"
          onChange={this.handleInputChange}
          type="text"
          value={height}
        />
        <Label className="font-weight-bold mt-4">Pick a Color</Label>
        <div className="d-flex justify-content-between flex-wrap">
          {Object.entries(AMP_PLACEMENT_SWATCHES).map(([index, color]) => (
            <button
              className={`border-0 rounded ${styles.swatch}`}
              data-test-id={`swatch-${color}`}
              disabled={this.isInProgress}
              key={color}
              onClick={this.handleSwatchClick}
              style={{ backgroundColor: color }}
              type="button"
              value={index}
            />
          ))}
        </div>
        <div className="d-flex mt-4">
          <ClearButton
            className="ml-auto"
            onClick={this.resetInputState}
            data-test-id="amp-modal-button-fpo-clear-all"
          >
            Clear All
          </ClearButton>
        </div>
      </div>
    );
  }
}
